import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface SignalActiveFiltersProps {
  filters: Array<{ key: string; label: string }>;
  onRemove: (key: string) => void;
  onClearAll: () => void;
}

export const SignalActiveFilters = ({
  filters,
  onRemove,
  onClearAll,
}: SignalActiveFiltersProps) => {
  const { t } = useTranslation('knowledge');

  if (filters.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      {filters.map((filter) => (
        <span
          key={filter.key}
          className="inline-flex items-center gap-1 rounded-md border border-gray-300 bg-white px-2.5 py-1 text-[11px] font-semibold text-[#5c554d]"
        >
          {filter.label}
          <button
            type="button"
            onClick={() => onRemove(filter.key)}
            className="ms-0.5 cursor-pointer hover:text-[#2c2520]"
          >
            <X className="h-3 w-3" />
          </button>
        </span>
      ))}
      {filters.length > 1 && (
        <button
          type="button"
          onClick={onClearAll}
          className="cursor-pointer text-[11px] font-medium text-[#8c8078] hover:text-[#5c554d]"
        >
          {t('clearAll')}
        </button>
      )}
    </div>
  );
};
